import toastr from "./_imports/toastr";
import i18n from "./lang";
import Swal from "sweetalert2";
import { Tooltip } from 'bootstrap';

// options BLOCK-UI
export const block_options = { overlayColor: "#FFF", opacity: 0.9 };
export const block_primary_modal = { overlayColor: "#302f2f", opacity: 0.9 };

export function catchDefaultError(error) {
    switch (error.status) {
        case 401: // Sessione scaduta
        case 419: // Token CSRF non valido
            // Questo errore viene già gestito tramite l'handler ajaxError
            return null;
        case 500:
            toastr.error(i18n("Internal server error"));
            return null;
        default:
            return error;
    }
}


export function updateURL_eventID(options, eventId) {
    options.ajax.url = options.ajax.url.replace("{eventId}", eventId);
    return options;
}

export function cleanObject(obj: object) {
    for (const key in obj) {
        if (obj[key] === undefined || obj[key] === null || obj[key] === "") delete obj[key];
    }

    return obj;
}

/**
 * Cerca "FAIL_message" in "FAIL_messages" e restituisce il relativo testo, altrimenti "default_text".
 *
 * @param FAIL_message Messaggi di errore restituito da AJAX.
 * @param FAIL_messages Array CHIAVE->VALORE con STRINGA_ERRORE->TESTO_DA_MOSTRARE.
 * @param default_text Messaggio da restituire se "FAIL_message" non è stata trovata in "FAIL_messages".
 *
 * @returns Messaggio di errore.
 */
export function getFAILMessage(FAIL_message: string, FAIL_messages: any, default_text: string): string {
    let text = ""; // testo da restituire

    // cerca in "FAIL_messages" "FAIL_message"
    for (const option_FAIL_message in FAIL_messages) if (option_FAIL_message === FAIL_message) text = FAIL_messages[option_FAIL_message];

    // testo se trovato, altrimenti "default_text"
    return text === "" ? default_text : text;
}

/**
 * Capitalizza le stringhe.
 *
 * @param s Stringa da capitalizzare.
 *
 * @returns Stringa capitalizzata.
 */
export function capitalize(s: string) {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
}

/**
 * Data una lista di oggetti restituisce un'array formattato per la funzione "setList" di jQuery Form Repeater.
 *
 * @param items Lista da utilizzare per la creazione del form repeater.
 * @param params Parametri da prendere nella lista, da utilizzare come "name" delle input del form repeater.
 *
 * @returns Array da passare alla funzione "setList" del form repeater.
 */
export function getRepeaterList(items: object[], params: string[]): object[] {
    const ret: object[] = []; // un oggetto per ogni input del blocco

    items.forEach(item => {
        const row: object = {};

        params.forEach(param => (row[param] = item[param]));

        ret.push(row);
    });

    return ret;
}

export const Toast = Swal.mixin(
{
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    onOpen: toast => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
});

export function delay(ms: number) {
    return new Promise<void>(resolve => {
        setTimeout(resolve, ms);
    });
}

export function handleDefaultError(error: any) {
    switch (error.status) {
        case 401: // Sessione scaduta
        case 419: // Token CSRF non valido
            Toast.fire({ type: "error", title: i18n("Expired session, log in again") });
            // Ritardo di 1500ms per dare all'utente il tempo di leggere
            // il messaggio prima del redirect
            delay(1500).then(() => window.location.reload());
            return true;
    }
    return false;
}

export function handleError(error: any) {
    switch (error.status) {
        case 403:
            Toast.fire({ type: "error", title: i18n("You don't have permission") });
            break;
    }
}

// formattazione name per ricerca in oggetto (con "_.get()" di LODHASH)
// ES. da "name[other][other_2]" in "name.other.other_2"
export function getDottedInputName(name: string): string
{
    if(name[name.length -1] === "]") name = name.substr(0, name.length -1);
    return name.split("[").join(".").split("]").join("");
}



/**
 * Restituisce il markup per renderizzare una serie di badge
 * a partire da una collection, mostrando all'interno del badge, per ogni item, il valore
 * dell'attributo interessato.
 *
 * @param {Record<string, any>[]}           collection Lista dalla quale comporre i badge.
 * @param {string}                          attribute  Attributo il cui valore deve essere mostrato all'interno di ciascun badge.
 * @param {number | undefined}              max        Numero massimo di badge da mostrare. Se non definito, mostra tutti, altrimenti mostra i primi e mette i restanti in un popover.
 * @param {Record<string, any> | undefined} options
 *
 * @returns {string}
 */
export function badgeListHTML(collection: Record<string, any>[], attribute: string, max: number | undefined = undefined/* , options: Record<string, any> | undefined = undefined */): string {
    // se non specifico un cap o il cap è oltre il numero di elementi da visualizzare, renderizza tutto
    if (max === undefined || max >= collection.length)
        return collection.map((el: Record<string, any>) => {
            return `<span class="kt-badge kt-badge--inline kt-badge--unified-dark mt-1 mb-1 text-nowrap">
                ${el[attribute]}
            </span>`
        }).join(" ");


    // badge subito visibili
    let markup: string = collection.slice(0, max).map((el: Record<string, any>) => {
        return `<span class="kt-badge kt-badge--inline kt-badge--unified-dark mt-1 mb-1 text-nowrap">${el[attribute]}</span>`;
    }).join(" ");

    const left: Record<string, any>[] = collection.slice(max);
    let leftHTML: string = left.map((el: Record<string, any>) => `<li>${el[attribute]}</li>`).join("");
    leftHTML = `<ul>${leftHTML}</ul>`;

    // aggiungi markup per visualizzare più badges.
    markup += `
        <a tabindex="0" data-toggle="popover" data-trigger="hover" data-html="true" data-placement="right" data-content="${leftHTML}">
            <span class="kt-badge kt-badge--inline kt-badge--unified-info kt-font-bold mt-1 mb-1 text-nowrap">
                +${left.length}
            </span>
        </a>`;

    return markup;
}

export function hideTooltip(tooltip: Array<Tooltip>)
{
    $.each(tooltip, function(i, element){
        tooltip[i].hide();
    });
}
